import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import {
  Box,
  FormControl,
  FormHelperText,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { DataGridPro } from "@mui/x-data-grid-pro";
import PropTypes from "prop-types";
import React from "react";
import { SELECT_HOURS_LIST, SELECT_MINUTES_LIST } from "../../util/constants";

const useStyles = makeStyles((theme) => ({
  messageBorder: {
    width: "230px",
  },
  sectionBox: {
    display: "inline-block",
    width: "100%",
  },
  timeInputBox: {
    display: "inline-block",
  },
  timeSelectInput: {
    width: "128px",
    maxWidth: "28vw",
  },
  timeColonBox: {
    display: "inline-block",
    fontSize: "20px",
    paddingLeft: "4px",
    paddingRight: "4px",
    lineHeight: "0",
    top: "9px",
    position: "relative",
  },
}));

const ScheduledHoursSegment = (props) => {
  const classes = useStyles();

  const renderActionsCell = (value) => {
    return props.shiftSegments.length > 1 && !props.scheduledHoursOffChecked ? (
      <Grid width={10}>
        <IconButton
          sx={{ padding: 0 }}
          onClick={() => {
            props.shiftSegments.splice(value.id - 1, 1);
            props.setShiftSegments([...props.shiftSegments]);
          }}
        >
          <RemoveCircleOutlineIcon color="primary" />
        </IconButton>
      </Grid>
    ) : (
      ""
    );
  };

  const getShiftSegmentsRows = () => {
    return props.shiftSegments.map((segment, index) => ({
      id: index + 1,
      shiftStartHr: segment.shiftStartHr,
      shiftStartMin: segment.shiftStartMin,
      shiftEndHr: segment.shiftEndHr,
      shiftEndMin: segment.shiftEndMin,
      shiftSegmentError: segment.shiftSegmentError,
    }));
  };

  const renderHours = () => {
    return SELECT_HOURS_LIST.map((hour) => {
      return (
        <MenuItem key={hour} value={parseInt(hour)}>
          {hour}
        </MenuItem>
      );
    });
  };

  const renderMinutes = () => {
    return SELECT_MINUTES_LIST.map((minute) => {
      return (
        <MenuItem key={minute} value={parseInt(minute)}>
          {minute}
        </MenuItem>
      );
    });
  };

  const getShiftSegmentsColumns = () => {
    let columns = [
      {
        field: "id",
        sortable: false,
        width: 56,
        hide: true,
        minWidth: 25,
        renderCell: (params) => {
          return <Typography sx={{ fontSize: "16px" }}>{params.row.id}</Typography>;
        },
      },
    ];

    columns.push({
      field: "shift",
      type: "string",
      minWidth: 280,
      sortable: false,
      renderCell: (params) => {
        return (
          <Grid container justifyContent="space-between" sx={{ flexDirection: "column" }}>
            <Grid item xs={1}>
              <Box className={classes.sectionBox} style={{ marginRight: "0px" }} mt={1} mb={1} mr={1}>
                <Grid container>
                  <Grid item xs={1} className={classes.messageBorder}>
                    <Box className={classes.timeInputBox}>
                      <FormControl variant="outlined">
                        <InputLabel
                          id="scheduledHoursStartHrLabel"
                          sx={{ marginTop: params.row.shiftStartHr ? "0px" : "-8px" }}
                          error={!!params.row.shiftSegmentError}
                        >
                          Start Hr
                        </InputLabel>
                        <Select
                          size="small"
                          labelId="scheduledHoursStartHrLabel"
                          id="scheduledHoursStartHrSelectElement"
                          className={classes.timeSelectInput}
                          value={params.row.shiftStartHr}
                          onChange={(event) => {
                            params.row.shiftStartHr = event.target.value;
                            let updatedSegments = [...props.shiftSegments];
                            updatedSegments[params.row.id - 1].shiftStartHr = event.target.value;
                            updatedSegments[params.row.id - 1].shiftSegmentError = "";
                            props.setShiftSegments(updatedSegments);
                          }}
                          label="Start Hr"
                          error={!!params.row.shiftSegmentError}
                          disabled={props.scheduledHoursOffChecked}
                        >
                          <MenuItem value="" disabled>
                            <em>Start Hr</em>
                          </MenuItem>
                          {renderHours()}
                        </Select>
                      </FormControl>
                    </Box>
                    <Box className={classes.timeColonBox}>:</Box>
                    <Box className={classes.timeInputBox}>
                      <FormControl variant="outlined">
                        <InputLabel
                          id="scheduledHoursStartMinLabel"
                          sx={{ marginTop: params.row.shiftStartMin ? "0px" : "-8px" }}
                          error={!!params.row.shiftSegmentError}
                        >
                          Start Min
                        </InputLabel>
                        <Select
                          size="small"
                          labelId="scheduledHoursStartMinLabel"
                          id="scheduledHoursStartMinSelectElement"
                          className={classes.timeSelectInput}
                          value={params.row.shiftStartMin}
                          onChange={(event) => {
                            params.row.shiftStartMin = event.target.value;
                            let updatedSegments = [...props.shiftSegments];
                            updatedSegments[params.row.id - 1].shiftStartMin = event.target.value;
                            updatedSegments[params.row.id - 1].shiftSegmentError = "";
                            props.setShiftSegments(updatedSegments);
                          }}
                          label="Start Min"
                          error={!!params.row.shiftSegmentError}
                          disabled={props.scheduledHoursOffChecked}
                        >
                          <MenuItem value="" disabled>
                            <em>Start Min</em>
                          </MenuItem>
                          {renderMinutes()}
                        </Select>
                      </FormControl>
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            </Grid>

            <Grid item xs={1}>
              <Box className={classes.sectionBox} style={{ marginRight: "0px" }} mt={1} mb={1} mr={1}>
                <Grid container>
                  <Grid item xs={1} className={classes.messageBorder}>
                    <Box className={classes.timeInputBox}>
                      <FormControl variant="outlined">
                        <InputLabel
                          id="scheduledHoursEndHrLabel"
                          sx={{ marginTop: params.row.shiftEndHr ? "0px" : "-8px" }}
                          error={!!params.row.shiftSegmentError}
                        >
                          End Hr
                        </InputLabel>
                        <Select
                          size="small"
                          labelId="scheduledHoursEndHrLabel"
                          id="scheduledHoursEndHrSelectElement"
                          className={classes.timeSelectInput}
                          value={params.row.shiftEndHr}
                          onChange={(event) => {
                            params.row.shiftEndHr = event.target.value;
                            let updatedSegments = [...props.shiftSegments];
                            updatedSegments[params.row.id - 1].shiftEndHr = event.target.value;
                            updatedSegments[params.row.id - 1].shiftSegmentError = "";
                            props.setShiftSegments(updatedSegments);
                          }}
                          label="End Hr"
                          error={!!params.row.shiftSegmentError}
                          disabled={props.scheduledHoursOffChecked}
                        >
                          <MenuItem value="" disabled>
                            <em>End Hr</em>
                          </MenuItem>
                          {renderHours()}
                        </Select>
                      </FormControl>
                    </Box>
                    <Box className={classes.timeColonBox}>:</Box>
                    <Box className={classes.timeInputBox}>
                      <FormControl variant="outlined">
                        <InputLabel
                          id="scheduledHoursEndMinLabel"
                          sx={{ marginTop: params.row.shiftEndMin ? "0px" : "-8px" }}
                          error={!!params.row.shiftSegmentError}
                        >
                          End Min
                        </InputLabel>
                        <Select
                          size="small"
                          labelId="scheduledHoursEndMinLabel"
                          id="scheduledHoursEndMinSelectElement"
                          className={classes.timeSelectInput}
                          value={params.row.shiftEndMin !== undefined ? params.row.shiftEndMin : ""}
                          onChange={(event) => {
                            params.row.shiftEndMin = event.target.value;
                            let updatedSegments = [...props.shiftSegments];
                            updatedSegments[params.row.id - 1].shiftEndMin = event.target.value;
                            updatedSegments[params.row.id - 1].shiftSegmentError = "";
                            props.setShiftSegments(updatedSegments);
                          }}
                          label="End Min"
                          error={!!params.row.shiftSegmentError}
                          disabled={props.scheduledHoursOffChecked}
                        >
                          <MenuItem value="" disabled>
                            <em>End Min</em>
                          </MenuItem>
                          {renderMinutes()}
                        </Select>
                      </FormControl>
                    </Box>
                    <FormHelperText error>{params.row.shiftSegmentError}</FormHelperText>
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          </Grid>
        );
      },
    });

    columns.push({
      field: "action",
      headerName: "",
      headerAlign: "left",
      align: "left",
      type: "string",
      width: 44,
      minWidth: 25,
      sortable: false,
      renderCell: (params) => {
        return renderActionsCell(params.row);
      },
    });

    return columns;
  };

  return (
    <div style={{ width: "100%" }} data-testid="scheduled-hours-segments-component">
      <DataGridPro
        columns={getShiftSegmentsColumns()}
        headerHeight={0}
        rows={getShiftSegmentsRows()}
        selectionModel={[]}
        getRowId={(row) => row.id}
        rowHeight={230}
        density="compact"
        disableColumnMenu={true}
        sx={{
          border: 0,
          "& .MuiDataGrid-footerContainer": {
            display: "none",
          },
        }}
        autoHeight={true}
      />
    </div>
  );
};

ScheduledHoursSegment.propTypes = {
  scheduledHoursOffChecked: PropTypes.bool.isRequired,
  shiftSegments: PropTypes.array.isRequired,
  setShiftSegments: PropTypes.func.isRequired,
};

export default ScheduledHoursSegment;
